import customAxios from "./axiosConfig";
import store from '../../store'

const TinkService = {
  listCredentials () {
    const api_url = window.Urls['tinkconnection_list_credentials']();
    return customAxios.get(api_url)
  },
  refreshCredentials (pk) {
    const api_url = window.Urls['v3:tinkconnection_refresh_credentials'](pk);
    return customAxios.get(api_url)
  },
  retrieveCountry () {
    const api_url = window.Urls['tinkconnection_provider_list']()
    return customAxios.get(api_url)
  },
  status () {
    const api_url = window.Urls['tinkconnection_status']()
    return customAxios.get(api_url)
  },
  signup(params) {
      var api_url = window.Urls["v3:tinkconnection_get_connect_link"]();
      return customAxios.post(api_url, params);
  },
  temporaryFixPayments(data){
    var url = window.Urls["invoice_fix_invoice_payments"]();
    return customAxios.post(url, data);
  },
  deleteAllGekkoCredentials() {
    var url = window.Urls["tinkconnection_delete_all_gekko_credentials"]();
    return customAxios.get(url);
  },
  deleteCredential(id) {
      var url = window.Urls["tinkconnection_delete_credential"](id);
      return customAxios.get(url);
  },
  debugUser() {
    var url = window.Urls["tinkconnection_debug_user"]();
    return customAxios.get(url);
  },
  debugBankAccounts(){
      var url = window.Urls["tinkconnection_debug_bank_accounts"]();
      return customAxios.get(url);
  },
  gekkoBankAccounts() {
      var url = window.Urls["tinkconnection_gekko_bank_accounts"]();
      return customAxios.post(url, {company_profile: store.getters['main/getCompanyId']});
  },
  debugCredential(id) {
      var url = window.Urls["tinkconnection_debug_credential"](id);
      return customAxios.get(url);
  },
  debugTransactions(params){
      var url = window.Urls["tinkconnection_debug_transactions"]();
      return customAxios.post(url, params);
  }
};

export default TinkService;